module.exports = __webpack_public_path__ + "img/icon-error.62b55002.svg";